import { VillageUpdatePage } from "@/features/geolocation/page/VillageUpdate";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/village/$id/update")({
  component: VillageUpdatePage,
});
